import {
	createMachine,
	EventObject,
	interpret,
	Interpreter,
	TypegenDisabled,
	ResolveTypegenMeta,
	BaseActionObject,
} from "xstate";

import { EventBus } from "@obg/event-bus";
import { EventBusContract } from "@obg/event-bus/types";

export class JourneyHandler {
	// Start FSM
	private journeyService:
		| Interpreter<
				object,
				any,
				EventObject,
				{
					value: any;
					context: object;
				},
				ResolveTypegenMeta<TypegenDisabled, EventObject, BaseActionObject, any>
		  >
		| undefined;

	constructor(
		config: Record<string, unknown>,
		private document: Document & {
			obgEventBus: EventBus<EventBusContract>;
		}
	) {
		this.journeyService = interpret(createMachine(config));

		// TODO: fix any to strong typing
		this.journeyService.subscribe((state: any) => {
			if (!state.changed) {
				return;
			}

			for (const action of state.actions) {
				// this is added for simple parameters such as shell:navigate.home
				const [actionName, actionParam] = action.type.split(".");

				// TODO: fix any type here - this too!
				// actionName and params cannot be determined if they need 2nd param or no because it's dynamic
				(this.document.obgEventBus.dispatch as any)(
					actionName,
					actionParam && {
						param: actionParam,
					}
				);
			}
		});

		this.journeyService.start();
	}

	/**
	 * Called on any global event to check against configured journeys
	 * - dispatches journey events in case there is match
	 * @param dispatchedCommand command name
	 */
	onGlobalEvent(dispatchedCommand: string) {
		// Sending event into FSM
		this.journeyService?.send(dispatchedCommand);
	}
}
